<template>
  <header class="reg-header">
    <div class="wrap">
      <div class="inner">
        <img
          src="../assets/hr3logo.png"
          alt="HR3 Logo"
          class="logo"
          @click="goHome"
        />

        <img
          src="../assets/back-icon.png"
          alt="Назад"
          class="back"
          @click="goBack"
        />

        <h1 class="title">{{ title }}</h1>
      </div>
    </div>
    <div class="separator"></div>
  </header>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  title: { type: String, required: true },
  emitBack: { type: Boolean, default: false },
});

const emit = defineEmits(["back"]);
const router = useRouter();

const goBack = () => (props.emitBack ? emit("back") : router.back());
const goHome = () => router.push("/feed");
</script>

<style scoped>
.reg-header {
  width: 100%;
  height: 70px;
  background: var(--header-bg-dark);
  display: flex;
  align-items: center;
  position: relative;
}
[data-theme="light"] .reg-header {
  background: var(--header-bg-light);
}

.wrap {
  width: 100%;
  height: 100%;
}

.inner {
  margin-left: 10%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo {
  width: 40px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.back {
  width: 20px;
  height: 18px;
  cursor: pointer;
  transition: opacity 0.2s;
  filter: invert(0);
}
[data-theme="light"] .back { filter: invert(1); }

.back:hover,
.logo:hover { opacity: .75; }

.title {
  font-size: 15px;
  font-family: "Eastman-Medium", sans-serif;
  color: var(--header-text-dark);
}
[data-theme="light"] .title { color: var(--header-text-light); }

.separator {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: var(--separator-dark);
  opacity: 0.9;
}
[data-theme="light"] .separator { background: var(--separator-light); }
</style>